import React, { Component } from 'react';
import PropTypes from "prop-types";
import { withRouter, Link } from 'react-router-dom';
import { bindActionCreators } from "redux";
import { RootActions } from "../../../shared/root-action";
import { connect } from "react-redux";
import AuthHelper from "../../../libraries/auth-helper";
import Logo from '../../../images/logo.png';
import Collapse from '@material-ui/core/Collapse';
import icond from '../../../images/menu/dash.svg';
import icon0 from '../../../images/menu/0.svg';
import icon1 from '../../../images/menu/1.svg';
import icon2 from '../../../images/menu/2.svg';
import icon3 from '../../../images/menu/3.svg';
import icon4 from '../../../images/menu/4.svg';
import icon5 from '../../../images/menu/5.svg';
import icon6 from '../../../images/menu/6.svg';
import icon7 from '../../../images/menu/7.svg';
import icon8 from '../../../images/menu/8.svg';
import icon9 from '../../../images/menu/9.svg';
import icon10 from '../../../images/menu/10.svg';
import icon11 from '../../../images/menu/11.svg';
import icon12 from '../../../images/menu/12.svg';
import icon13 from '../../../images/menu/13.svg';
import iconmenu from '../../../images/menu/menu.svg';
import profile from '../../../images/menu/profile.svg';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import { history } from "../../../shared/configure-store";

class Sidebar extends Component {
    static propTypes = {
        match: PropTypes.object.isRequired,
        location: PropTypes.object.isRequired,
        history: PropTypes.object.isRequired
    };

    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            menus: [],
            name: '',
            role: '',
            top: false,
            data: false,
            client: false,
            projects: false,
            finance: false,
            tasks: false,
            product: false,
            customer: false,
            blogs: false,
            pages: false,
            permissions: [],
        };
    }

    componentDidMount() {
        document.title = 'Gudangemas - Produk';
    
        const profile = AuthHelper.getProfile();
        if (profile['map-menu']) {
            let roles = profile['map-menu'].map(o => {
                return {
                    id: o.id,
                    name: o.menu.name,
                    isCreate: o.isCreate,
                    isManage: o.isManage,
                }
            });
            this.setState({
                name: profile['full-name'],
                role: profile['role'],
                permissions: roles,
            })
        }
    
        const { location } = this.props;
        const text = location.pathname.split('/');
        let initialState = {};
        if (text.includes('customers') || text.includes('companies') || text.includes('regional-setup') || text.includes('regional')) initialState.customer = true;
        if (text.includes('products') || text.includes('categories') || text.includes('sub-categories')) initialState.product = true;
        if (text.includes('pages') || text.includes('homes') || text.includes('abouts')) initialState.pages = true;
        if (text.includes('blogs') || text.includes('blogs-categories')) initialState.blogs = true;
        this.setState(initialState);
    }

    openMenu = (menu) => {
        this.setState((prevState) => ({ [menu]: !prevState[menu] }));
    };

    isActiveRoute = (route) => {
        const { location } = this.props;
        return location.pathname.startsWith(route);
    };

    checkPermission = (name) => {
        let all = this.state.permissions.filter((item) => item.name === name);
        if (all.length > 0 && all[0].isCreate)
            return true;
    };

    handleLogout = () => {
        AuthHelper.logOut();
    };

    handleGo = (link) => {
        history.push(link);
    };

    CustomLink = to => <Link to={to} />;

    render() {
        const { location } = this.props;
        const text = location.pathname.split("/");

        return (
            <aside className={"side-nav " + (this.props.toggle_sidebar_state ? "show" : "hide")}>
                <header className="d-none d-lg-block">
                    <nav className="navbar justify-content-center">
                        <Link to="/" className="navbar-brand m-0 p-0">
                            <img src={Logo} alt='gudangemas' className='img-fluid' />
                        </Link>
                    </nav>
                </header>

                <ul className="nav flex-column">
                    <List
                        component="nav"
                        aria-labelledby="nested-list-subheader"
                    >
                        {this.checkPermission('Dashboard') && (
                            <ListItem href='/' className={location.pathname === '/' ? 'active' : ''} component='a' button>
                                <ListItemIcon><img src={icond} alt='ge-icon' className='img-icon' /></ListItemIcon>
                                <ListItemText primary="Dashboard" />
                            </ListItem>
                        )}

                        {this.checkPermission('Customer') && (
                            <ListItem onClick={() => this.openMenu('customer')} button>
                                <ListItemIcon><img src={icon0} alt='ge-icon' className='img-icon' /></ListItemIcon>
                                <ListItemText primary="Customer" />
                            </ListItem>
                        )}
                        <Collapse in={this.state.customer} timeout="auto" unmountOnExit>
                            <List component="div" disablePadding>
                                {this.checkPermission('Customer') && (
                                    <>
                                        <ListItem href='/customers/individual' className={location.pathname.startsWith('/customers/individual') ? 'active' : ''} component='a' button>
                                            <ListItemText primary="Individu" />
                                        </ListItem>
                                        <ListItem href='/customers/corporate' className={location.pathname.startsWith('/customers/corporate') ? 'active' : ''} component='a' button>
                                            <ListItemText primary="Corporate" />
                                        </ListItem>
                                        <ListItem href='/companies' className={location.pathname.startsWith('/companies') ? 'active' : ''} component='a' button>
                                            <ListItemText primary="Data Company" />
                                        </ListItem>
                                        <ListItem href='/regional' className={location.pathname === '/regional' ? 'active' : ''} component='a' button>
                                            <ListItemText primary="Daftar Regional" />
                                        </ListItem>
                                        <ListItem href='/regional-setup' className={location.pathname.startsWith('/regional-setup') ? 'active' : ''} component='a' button>
                                            <ListItemText primary="Regional Setup" />
                                        </ListItem>

                                    </>
                                )}
                            </List>
                        </Collapse>

                        {this.checkPermission('Admin') && (
                            <ListItem href='/admins' className={text[1] === 'admins' ? 'active' : ''} component='a' button>
                                <ListItemIcon><img src={icon1} alt='ge-icon' className='img-icon' /></ListItemIcon>
                                <ListItemText primary="Admin" />
                            </ListItem>
                        )}

                        {this.checkPermission('Riwayat Order') && (
                            <ListItem href='/orders' className={text[1] === 'orders' ? 'active' : ''} component='a' button>
                                <ListItemIcon><img src={icon3} alt='ge-icon' className='img-icon' /></ListItemIcon>
                                <ListItemText primary="Riwayat Order" />
                            </ListItem>
                        )}

                        {this.checkPermission('Daftar Produk') && (
                            <ListItem onClick={() => this.openMenu('product')} button>
                                <ListItemIcon><img src={icon4} alt='ge-icon' className='img-icon' /></ListItemIcon>
                                <ListItemText primary="Produk" />
                            </ListItem>
                        )}
                        <Collapse in={this.state.product} timeout="auto" unmountOnExit>
                            <List component="div" disablePadding>
                                <ListItem href='/products' className={location.pathname.startsWith('/products') && location.pathname !== '/products/add' && location.pathname !== '/products/import'  ? 'active' : ''} component='a' button>
                                    <ListItemText primary="Daftar Produk" />
                                </ListItem>
                                <ListItem href='/products/add' className={location.pathname === '/products/add' ? 'active' : ''} component='a' button>
                                    <ListItemText primary="Tambah Produk" />
                                </ListItem>
                                <ListItem href='/products/import' className={location.pathname === '/products/import' ? 'active' : ''} component='a' button>
                                    <ListItemText primary="Import Produk" />
                                </ListItem>
                                {this.checkPermission('Daftar Produk') && (
                                    <ListItem href='/categories' className={location.pathname.startsWith('/categories') ? 'active' : ''} component='a' button>
                                        <ListItemText primary="Kategori" />
                                    </ListItem>
                                )}
                                {this.checkPermission('Daftar Produk') && (
                                    <ListItem href='/sub-categories' className={location.pathname.startsWith('/sub-categories') ? 'active' : ''} component='a' button>
                                        <ListItemText primary="Tag Kategori" />
                                    </ListItem>
                                )}
                            </List>
                        </Collapse>

                        {this.checkPermission('Riwayat Point') && (
                            <ListItem href='/points' className={text[1] === 'points' ? 'active' : ''} component='a' button>
                                <ListItemIcon><img src={icon5} alt='ge-icon' className='img-icon' /></ListItemIcon>
                                <ListItemText primary="Riwayat Poin" />
                            </ListItem>
                        )}

                        {this.checkPermission('Pengaturan Point') && (
                            <ListItem href='/point-settings' className={text[1] === 'point-settings' ? 'active' : ''} component='a' button>
                                <ListItemIcon><img src={icon6} alt='ge-icon' className='img-icon' /></ListItemIcon>
                                <ListItemText primary="Pengaturan Poin" />
                            </ListItem>
                        )}

                        {this.checkPermission('Kupon') && (
                            <ListItem href='/coupons' className={text[1] === 'coupons' ? 'active' : ''} component='a' button>
                                <ListItemIcon><img src={icon7} alt='ge-icon' className='img-icon' /></ListItemIcon>
                                <ListItemText primary="Kupon" />
                            </ListItem>
                        )}

                        {this.checkPermission('Comments') && (
                            <ListItem href='/comments' className={text[1] === 'comments' ? 'active' : ''} component='a' button>
                                <ListItemIcon><img src={icon10} alt='ge-icon' className='img-icon' /></ListItemIcon>
                                <ListItemText primary="Reviews" />
                            </ListItem>
                        )}

                        {this.checkPermission('Halaman') && (
                            <ListItem onClick={() => this.openMenu('pages')} button>
                                <ListItemIcon><img src={icon11} alt='ge-icon' className='img-icon' /></ListItemIcon>
                                <ListItemText primary="Pages" />
                            </ListItem>
                        )}
                        <Collapse in={this.state.pages} timeout="auto" unmountOnExit>
                            <List component="div" disablePadding>
                                <ListItem href='/pages' className={location.pathname === '/pages' ? 'active' : ''} component='a' button>
                                    <ListItemText primary="Halaman" />
                                </ListItem>
                                <ListItem href='/homes' className={location.pathname === '/homes' ? 'active' : ''} component='a' button>
                                    <ListItemText primary="Home" />
                                </ListItem>
                                <ListItem href='/abouts' className={location.pathname === '/abouts' ? 'active' : ''} component='a' button>
                                    <ListItemText primary="About" />
                                </ListItem>
                            </List>
                        </Collapse>

                        {this.checkPermission('Blog') && (
                            <ListItem onClick={() => this.openMenu('blogs')} button>
                                <ListItemIcon><img src={icon12} alt='ge-icon' className='img-icon' /></ListItemIcon>
                                <ListItemText primary="Blogs" />
                            </ListItem>
                        )}
                        <Collapse in={this.state.blogs} timeout="auto" unmountOnExit>
                            <List component="div" disablePadding>
                                <ListItem href='/blogs' className={location.pathname === '/blogs' ? 'active' : ''} component='a' button>
                                    <ListItemText primary="Blog" />
                                </ListItem>
                                <ListItem href='/blogs-categories' className={location.pathname === '/blogs-categories' ? 'active' : ''} component='a' button>
                                    <ListItemText primary="Blog Categories" />
                                </ListItem>
                            </List>
                        </Collapse>

                        {this.checkPermission('Kuis') && (
                            <ListItem href='/quiz' className={text[1] === 'quizzes' ? 'active' : ''} component='a' button>
                                <ListItemIcon><img src={icon13} alt='ge-icon' className='img-icon' /></ListItemIcon>
                                <ListItemText primary="Kuis" />
                            </ListItem>
                        )}

                        {this.checkPermission('Menus') && (
                            <ListItem href='/menus' className={text[1] === 'menus' ? 'active' : ''} component='a' button>
                                <ListItemIcon><img src={iconmenu} alt='ge-icon' className='img-icon' /></ListItemIcon>
                                <ListItemText primary="Menus" />
                            </ListItem>
                        )}

                        {this.checkPermission('Pengaturan') && (
                            <ListItem href='/settings' className={text[1] === 'settings' ? 'active' : ''} component='a' button>
                                <ListItemIcon><img src={icon9} alt='ge-icon' className='img-icon' /></ListItemIcon>
                                <ListItemText primary="Pengaturan" />
                            </ListItem>
                        )}

                        {this.checkPermission('Media') && (
                            <ListItem href='/medias' className={text[1] === 'media' ? 'active' : ''} component='a' button>
                                <ListItemIcon><img src={icon8} alt='ge-icon' className='img-icon' /></ListItemIcon>
                                <ListItemText primary="Media" />
                            </ListItem>
                        )}

                        {this.checkPermission('Role Permission') && (
                            <ListItem href='/roles' className={text[1] === 'roles' ? 'active' : ''} component='a' button>
                                <ListItemIcon><img src={icon2} alt='ge-icon' className='img-icon' /></ListItemIcon>
                                <ListItemText primary="Roles" />
                            </ListItem>
                        )}
                    </List>

                    <li className="nav-item profile-picture">
                        {/* <img src={profile} className='img-profile' alt='profile' />*/}
                        <div className="content">
                            <h3>{this.state.name}</h3>
                            <span>{this.state.role}</span>
                            <strong onClick={this.handleLogout} style={{ cursor: 'pointer' }}>Log Out</strong>
                        </div>
                    </li>
                </ul>
            </aside>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        toggle_sidebar_state: state.toggle_sidebar_state,
        profile_state: state.profile_state,
        permission_state: state.permission_state,
    };
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(RootActions, dispatch)
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Sidebar));